import jsonapi from 'jsonapi-parse';
import BasketOrder from '@/models/read/BasketOrder';

export default $axios => () => ({
    async listPlagiarismOrders() {
        let response = await $axios.$get(`/api/v1/basket/plagiarism-orders`);
        return jsonapi.parse(response).data.map(o => new BasketOrder(o)).sort((a, b) => a.draftedAt > b.draftedAt ? -1 : 1);
    },
    async getBasketPlagiarismOrderById(orderId) {
        let response = await $axios.$get(`/api/v1/basket/plagiarism-orders/${orderId}`);
        return new BasketOrder(jsonapi.parse(response).data);
    },
    async listProofreadingOrders() {
        let response = await $axios.$get(`/api/v1/basket/proofreading-orders`);
        return jsonapi.parse(response).data.map(o => new BasketOrder(o)).sort((a, b) => a.draftedAt > b.draftedAt ? -1 : 1);
    },
    async getBasketProofreadingOrderById(orderId) {
        let response = await $axios.$get(`/api/v1/basket/proofreading-orders/${orderId}`);
        return new BasketOrder(jsonapi.parse(response).data);
    },
    async listAIProofreaderOrders() {
        let response = await $axios.$get(`/api/v1/basket/ai-proofreader-orders`);
        return jsonapi.parse(response).data.map(o => new BasketOrder(o)).sort((a, b) => a.draftedAt > b.draftedAt ? -1 : 1);
    },
    async getAIProofreaderOrder(orderId) {
        let response = await $axios.$get(`/api/v1/basket/ai-proofreader-orders/${orderId}`);
        return new BasketOrder(jsonapi.parse(response).data);
    },
});
